export default {"src":"/_next/static/media/0x1494ca1f11d487c2bbe4543e90080aeba4ba3c2b.fa2e870e.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};